import * as React from 'react';
import { Alert } from '@grandvisionhq/common';
import { Heading } from '@grandvisionhq/elements';
import { useIntl } from '@grandvisionhq/state';
import EmailForm from '../../components/EmailForm/EmailForm.js';
import { formatError } from '../../Util/format-error.js';

const ExpiredLinkView = ({ onResend , titleLabelKey , loginUrl , isLoading , hasError ,  })=>{
    const { getLabel  } = useIntl();
    const [isEmailSent, setIsEmailSent] = React.useState(false);
    const error = React.useMemo(()=>{
        return hasError ? new Error(getLabel('account.createAccount.signup.errors.general')) : undefined;
    }, [
        hasError,
        getLabel
    ]);
    const handleSubmit = React.useCallback((email)=>{
        if (isEmailSent && !hasError || isLoading) {
            return;
        }
        onResend({
            email
        });
        setIsEmailSent(true);
    }, [
        isEmailSent,
        hasError,
        isLoading,
        onResend
    ]);
    const canResend = !isEmailSent || error;
    return /*#__PURE__*/ React.createElement("div", {
        className: "expired-link myaccount__section",
        "data-t": "expired-link"
    }, /*#__PURE__*/ React.createElement(Heading, {
        variant: "medium"
    }, getLabel(titleLabelKey)), /*#__PURE__*/ React.createElement(Alert, {
        type: "info",
        title: getLabel('account.linkExpired.title'),
        message: getLabel('account.linkExpired.message')
    }), error && /*#__PURE__*/ React.createElement(Alert, {
        type: "error",
        message: formatError(error)
    }), /*#__PURE__*/ React.createElement(EmailForm, {
        onSubmit: handleSubmit,
        emailErrorLabel: getLabel('account.error.emailInvalid'),
        emailLabel: getLabel('fields.input.email.label'),
        buttonLabel: !canResend ? getLabel('account.action.emailSent') : getLabel('account.action.requestLink'),
        isButtonDisabled: !canResend,
        isButtonLoading: isLoading
    }), /*#__PURE__*/ React.createElement("a", {
        href: loginUrl,
        "data-t": "to-login",
        className: "expired-link__text"
    }, getLabel('account.action.returnToLogin')));
};
var ExpiredLinkView$1 = ExpiredLinkView;

export { ExpiredLinkView$1 as default };
//# sourceMappingURL=ExpiredLinkView.js.map
